<template lang="html">
  <div class="qr-watch-gallery">
    <swiper class="swiper qr-watch-gallery__swiper" :options="swiperOptions">
      <swiper-slide v-for="(src, idx) in images" :key="'qr-gal-' + idx">
        <div class="box-image">
          <img src="public/images/shared/empty.png" v-bind:style="{ backgroundImage: 'url('+src.imageUrl+')' }">
        </div>
      </swiper-slide>
      <!-- <div v-if="images.length > 1" class="swiper-button-prev" slot="button-prev"></div>
      <div v-if="images.length > 1" class="swiper-button-next" slot="button-next"></div> -->
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  name: 'QrWatchGallery',

  props: {
    images: {},
  },

  data() {
    return {
      swiperOptions: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true,
        },
      }
    }
  },
};
</script>